import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              onClick={() => setOpenId(isOpen ? null : item.id)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-primary-50/60 md:px-5"
            >
              <span className="flex items-start gap-3">
                <i className="ri-question-line mt-0.5 text-primary-500"></i>
                <span className="text-sm font-medium text-foreground-900 md:text-base">{item.question}</span>
              </span>
              <i
                className={`shrink-0 text-foreground-400 transition-transform ${
                  isOpen ? "ri-subtract-line" : "ri-add-line"
                }`}
              ></i>
            </button>
            {isOpen && (
              <div className="bg-background-100/70 px-4 pb-4 pt-0 md:px-5">
                <p className="border-l-2 border-accent-300 pl-4 text-sm leading-relaxed text-foreground-700">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}